// extracted by mini-css-extract-plugin
module.exports = {"dataDetail":"DataDetail_dataDetail_kaQfS"};